import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

// occurredAt is the caller's timestamp, not one taken here -- see buildItemDeletedActivityEntry
// for why (same delete-request-await shape).
export function buildDayDeletedActivityEntry(dayTitle: string, sourcePath: 'trip_planner.itinerary.day_canvas.delete_day', occurredAt: string): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'day_deleted',
    label: 'Deleted itinerary day',
    displayText: boundActivityDisplayText(`Removed "${dayTitle}" from the itinerary`),
    sourcePath,
    dataClassification: 'personalised_surface',
    occurredAt,
  }
}
